import { createSlice } from "@reduxjs/toolkit";

const initialHomeworkAnswer = {
  explanation: ""
};

const initialHomeworksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  homeworkAnswer: initialHomeworkAnswer
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const studentHomeworkSlice = createSlice({
  name: "studentHomeworks",
  initialState: initialHomeworksState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getHomeworks
    homeworksFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.teachers = entity.teachers;
      state.sections = entity.sections;
      state.courses = entity.courses;
    },
    // getHomeworkAnswer
    homeworkAnswerFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;      
      state.homeworkAnswer = entity;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanAnswerState
    answerStateCleaned: (state) => {
      state.homeworkAnswer = initialHomeworkAnswer;
    },
    // cleanHomeworksState
    homeworksStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});